import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Spinner = styled(ClipLoader).attrs((props) => ({
  color: props.color,
}))``;
